import Hero from '@components/hero/5'
import React from 'react'
import { Division, RealEstateDataPageComponentData } from 'types'

const Hero_7 = (props: RealEstateDataPageComponentData & { divisions: Division[] }) => {
  return <Hero {...props} />
}

export default Hero_7
